/**
 * StatCounter — a compact label + prominent number display.
 * Used in dashboard-style stat rows across the app.
 */
import Box from '@cloudscape-design/components/box';

interface StatCounterProps {
  label: string;
  value: string | number | null | undefined;
  description?: string;
}

export function StatCounter({ label, value, description }: StatCounterProps) {
  const isEmpty = value === null || value === undefined;
  return (
    <div>
      <Box variant="awsui-key-label">{label}</Box>
      <Box
        fontSize="heading-xl"
        color={isEmpty ? 'text-body-secondary' : 'inherit'}
      >
        {isEmpty ? '—' : value}
      </Box>
      {description && (
        <Box color="text-body-secondary" fontSize="body-s">
          {description}
        </Box>
      )}
    </div>
  );
}
